import { ORDER_STATUS_META, PAYMENT_STATUS_META } from "../lib/format";

export function StatusBadge({ status }) {
    const meta = ORDER_STATUS_META[status] || {
        label: status,
        color: "bg-slate-500/15 text-slate-300 border-slate-500/30",
    };
    return (
        <span className={`status-pill border ${meta.color}`}>{meta.label}</span>
    );
}

export function PaymentBadge({ status }) {
    const meta = PAYMENT_STATUS_META[status] || {
        label: status,
        color: "bg-slate-500/15 text-slate-300 border-slate-500/30",
    };
    return (
        <span className={`status-pill border ${meta.color}`}>{meta.label}</span>
    );
}
